import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import { TooltipContainer, TooltipFloating, TooltipText } from "./index.styled";

const Info = ({
  children,
  config,
  icon = null,
  showArrow = true,
  position = "center",
  align = "center",
  disabled = false,
}) => {
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const containerRef = useRef(null);
  const tooltipRef = useRef(null);

  const updateTooltipPosition = () => {
    if (containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      const top = rect.bottom + window.scrollY + (config?.offsetY || 20);
      let left = rect.left + window.scrollX;
      if (align === "center") {
        left = rect.left + rect.width / 2 + window.scrollX;
      } else if (align === "end") {
        left = rect.right + window.scrollX;
      }
      setTooltipPosition({ top, left });
    }
  };

  const handleMouseEnter = () => {
  if (!disabled && config?.tooltipText) {
    updateTooltipPosition();
    setTooltipVisible(true);
  }
};

  const handleMouseLeave = () => {
    setTooltipVisible(false);
  };

  const handleClickInside = (e) => {
    // Hide tooltip when clicking inside `Info`
    if (containerRef.current?.contains(e.target)) {
      setTooltipVisible(false);
    }
  };
  useEffect(() => {
    window.addEventListener("resize", updateTooltipPosition);
    document.addEventListener("click", handleClickInside);
    return () => {
      window.removeEventListener("resize", updateTooltipPosition);
      document.removeEventListener("click", handleClickInside);
    };
  }, [config?.offsetY, config?.offsetX, position]);

  return (
    <TooltipContainer
      ref={containerRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClickInside}
    >
      {children}
      {!disabled && config?.tooltipText && // Render tooltip only if tooltipText is not null or empty
        ReactDOM.createPortal(
          <>
          {align == "center" ? (
              <TooltipText
                ref={tooltipRef}
                showArrow={showArrow}
                tooltipVisible={tooltipVisible}
                style={{
                  position: "absolute",
                  top: tooltipPosition.top,
                  left:
                  position == "start"
                      ? tooltipPosition.left - 40
                    : position == "end"
                      ? tooltipPosition.left + 20
                      : tooltipPosition.left,
                  zIndex: 1000,
                  whiteSpace: "nowrap",
                }}
                config={config}
              >
                {icon && <span>{icon}</span>}
                {config?.tooltipText}
              </TooltipText>
            ) : (
              <TooltipFloating
                showArrow={showArrow}
                tooltipVisible={tooltipVisible}
                config={config}
                style={{
                  position: "absolute",
                  top: tooltipPosition.top,
                  left: align !== "right-end" && tooltipPosition.left,
                  right: align === "right-end" && 40,
                  transform:
                    align === "center"
                      ? "translateX(-50%)"
                      : align === "end"
                      ? "translateX(-100%)"
                      : "none",
                  zIndex: 1000,
                  whiteSpace: "nowrap",
                }}
              >
                {icon && <span>{icon}</span>}
                {config?.tooltipText}
              </TooltipFloating>
            )}
        </>
      ,
        document.body,
        )}
    </TooltipContainer>
  );
};

export default Info;